import { render, staticRenderFns } from "./PodCard.vue?vue&type=template&id=18090bd9&scoped=true&class=pod-card&"
import script from "./PodCard.vue?vue&type=script&lang=ts&"
export * from "./PodCard.vue?vue&type=script&lang=ts&"
import style0 from "./PodCard.vue?vue&type=style&index=0&id=18090bd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18090bd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCol,VContainer,VProgressCircular,VRow,VSpacer,VToolbar,VToolbarTitle})
